import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Header } from "../../../components/header";
import { SendIcon } from "../../../components/icons";
import { Loading } from "../../../components/loading";

import { ProductForm } from "../components";
import { useProduct, useUpdateProduct } from "../hooks";

type IUpdateProduct = {
  id: string;
};

export const UpdateProduct: React.FC = () => {
  const { id } = useParams<IUpdateProduct>();
  const navigate = useNavigate();
  useEffect(() => {
    if (!id) {
      navigate("/");
    }
  }, []);
  const { data, refetch } = useProduct(+id!);

  const { form, submit, loading } = useUpdateProduct({
    id: +id!,
    onCompleted: () => {
      refetch();
      toast.success("Le client a été modifié avec succès");
    },
    onError(message) {
      toast.error(message);
    },
  });

  useEffect(() => {
    if (data) {
      form.setValue("name", data.product.result?.name);
      form.setValue("url", data.product.result?.url);
      form.setValue("imgUrl", data.product.result?.imgUrl);
      form.setValue("reference", data.product.result?.reference);
      form.setValue("lastQuantity", data.product.result?.lastQuantity);
      form.setValue("lastPrice", data.product.result?.lastPrice);

      // form.setValue("imgUrl", data.product.result?.imgUrl);
      // form.setValue("reference", data.product.result?.reference);
    }
  }, [data]);

  if (!data) {
    return <Loading />;
  }
  return (
    <>
      <Header
        title={"Produit"}
        subtitle="Modifier les informations du produit"
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: `/product/${id}`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <ProductForm loading={loading} form={form} submit={submit} />
      </div>
    </>
  );
};
